var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftPlum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2066 2.38671C12.7141 1.78057 11.8586 1.71915 11.2957 2.24952L4.79572 8.37452C4.13219 8.99976 4.13219 10.236 4.79572 10.8612L11.2957 16.9862C11.8586 17.5166 12.7141 17.4551 13.2066 16.849C13.699 16.2429 13.642 15.3216 13.0792 14.7912L7.58329 9.472L13.0792 4.44453C13.642 3.91416 13.699 2.99284 13.2066 2.38671Z",
    fill: "#3F2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftPlum);
export default __webpack_public_path__ + "static/media/chevronLeftPlum.7ec851eefec767fafe6e322f8a341474.svg";
export { ForwardRef as ReactComponent };